import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { SecurityApiClient } from "../api-client/api-client";
import type { SendSensitiveEmailCodeResponse, SensitiveEmail } from "../types";
export default function useRequestSensitiveEmailMutation(
  options?: UseMutationOptions<SendSensitiveEmailCodeResponse, Error, SensitiveEmail>
) {
  const { t } = useTranslation(["pass"]);
  const { leUuid } = useCompanyContext();
  const { getLanguage } = usei18n();
  return useMutation<SendSensitiveEmailCodeResponse, Error, SensitiveEmail>({
    mutationFn: async (args: SensitiveEmail) => {
      const data = await SecurityApiClient.requestSensitiveEmail(
        args.email,
        getLanguage(),
        args.actionType,
        args?.actionData,
        leUuid ?? undefined
      );
      if (!data.success) {
        throw new Error(t("flow.id_control.error.check_email"));
      }
      return data;
    },
    ...options
  });
}
